import type { FaireProductEntity } from "../../entity_types/product";

export const p_gqcrwe7za2: FaireProductEntity = {
  token: "p_gqcrwe7za2",
  type: "product",
  name: "LAS Casual Solid Oversize Tee Shorts 2pcs Outfit (S-XL)",
  brandToken: "b_11782mgvt5",
  brandName: "LA Society",
  imageUrl:
    "https://cdn.faire.com/fastly/74c207e95c123bb540eecaa4fca0e98ea9e083787541a18231b59bae1f56e66d.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bd9b53508f4ac47915499ff491fa4abda32639295ee91eebab9ca4dd83185f3c.png",
    "https://cdn.faire.com/fastly/d4f5d36fe388a940713860d05f3cb2c40dd1fde317f64b74d37ebfee9a2d35e3.png",
    "https://cdn.faire.com/fastly/b7dfcda6fb5698e20b5cb4d32ac87c9ed42870e36294e92bfd1efc87df6de1a9.png",
    "https://cdn.faire.com/fastly/1cff2bd971bbf85b3858474cc0185a5f581be5d229ac23dbcd4228322ad0d3f8.png",
    "https://cdn.faire.com/fastly/26b11710092b9b142dfb9ac3aa66389058d5088db97076671ae726f003c1bb1f.png",
    "https://cdn.faire.com/fastly/8ffffe55585db5f76d5c6ad89506f7aef1f5f8ad67e4695ce273b27c099b3339.png",
    "https://cdn.faire.com/fastly/f45268df48184a51f87464abec0f4abdced4e95053c0108a4518585df7b769cd.png",
  ],
  priceDollars: 24.9,
  description:
    "✨Material: 50%Polyester+43%Viscose+7%Elastane\n✨Pattern: Solid\n✨Sleeve: Half Sleeve\n✨Neck: Mock Neck\n\nTOP Size Chart (INCH)\nSize\t \tBust\tHem  \tShoulder\tSleeve  \tLength\n  S\t \t44.1\t    42.9\t    22.0\t       8.7\t      28.7\n  M\t \t46.5\t45.3\t    23.2\t       8.7\t      29.5\n  L\t \t48.8\t47.6\t        24.4\t       8.7\t      30.3\n XL\t \t52.0\t50.8\t    26.0\t       8.7\t      31.1\n\nPANTS Size Chart (INCH)\nSize\t \tWaist\t Hip\tFront Rise\tInseam\tOutseam\n  S\t \t26.4\t41.7\t      11.9\t       3.3\t         12.2\n  M\t \t28.7\t    44.1\t      12.2\t       3.3\t         12.6\n  L\t \t31.1\t    46.5\t  12.5\t       3.4\t         13.0\n XL\t \t34.3\t49.6\t  12.9\t       3.4\t         13.4\n\n👏 Tag Customization Service: \nEach item comes with a care label that includes size information. We also offer custom brand labels and hang tags. If you need this service, feel free to reach out to us anytime! 💕",
  tags: [],
  msrpDollars: 49.8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:51:51.693Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
